export default __webpack_public_path__ + "static/media/Appstore.d0c58399.png";